import service from "../Services/service";
export async function GroupListhooks(searchTerm, sortBy, sortDescending, pageNumber, pageSize, moduleId) {
    var userId = localStorage.getItem("userId")
    var data;
    await service.getdata("Group/GetAll?searchTerm=" + searchTerm + "&sortBy=" + sortBy + "&sortDescending=" + sortDescending + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize +"&userId=" + userId + "&moduleId=" + moduleId).then((res) => {
        data = res.data;
    });
    return data;
}

export async function CreateGrouphooks(formData) {
    var data;
    await service.createorupdate("Group/CreateOrUpdate", formData)
        .then(res => {
            //  setApiResponse(res.data); // Set the API response in state  
            data = res.data;
        })
        .catch(error => {
            // Handle error if API call fails
            console.error("API Error:", error);

        });
    return data;
}

export async function GroupGetbyIdhooks(id) {
    var data;
    await service.getdatabyId("Group/GetById?id=",id).then((res) => {
        data = res.data;
    });
    return data;
}

export async function AddScreensInGroup(formData) {
    var data;
    await service.createorupdate("Group/AddScreensInGroup", formData)
        .then(res => {
            //  setApiResponse(res.data); // Set the API response in state  
            data = res.data;
        })
        .catch(error => {
            // Handle error if API call fails
            console.error("API Error:", error);

        });
    return data;
}

export async function GetByGroupId(id) {
    var data;
    await service.getdatabyId("Group/GetByGroupId?id=",id).then((res) => {
        data = res.data;
    });
    return data;
}